import { action, computed, observable } from 'mobx'
import RootStore from './RootStore'

export interface NotationItemProps {
	title: string
	body: string
	positionX?: number
	positionY?: number
	translateX?: number
	translateY?: number
	buttonRect?: ClientRect | DOMRect
	visible?: boolean
	destroy: Function
	id: string
}

export class NotationStore {
	@observable public anchorObj: HTMLElement | null
	@observable public title: string
	@observable public body: string
	@observable public rootStore: RootStore

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
	}

	@computed get visible(): boolean {
		return !!this.anchorObj
	}
	@action setActiveItem(anchorObj: HTMLElement, title: string, body: string) {
		this.anchorObj = anchorObj
		this.title = title
		this.body = body
	}
	@action clear() {
		this.anchorObj = null
		this.title = ''
		this.body = ''
	}
}
